<template>
  <div class="template-page">
    <div class="template-header">
      <span>在线模板</span>
      <div class="create-btn-box" style="width: 250px;">
        <a href="javascript:;" @click="handleShowControl">
          <img style="position: relative;top: 5px;" src="../assets/power.png" /> 权限管理
        </a>
        <el-button
          class="create-btn"
          style="margin-left:20px;"
          type="primary"
          @click="handleCreateTempate"
        >创建模板</el-button>
      </div>
    </div>
    <div v-if="totalCount > 0" class="survey-container">
      <el-row class="mine-list">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            class="th-column"
            prop="title"
            label="标题"
            show-overflow-tooltip
            width="500"
          >
            <template slot-scope="scope">
              <a
                href="javascript:;"
                v-if="!scope.row.editRemark"
                @click="handleEdit(scope.row)"
                class="wj-name"
              >
                <svg class="icon svg-icon wj-survey-icon" aria-hidden="true">
                  <use xlink:href="#icon-icon_wenjuan" />
                </svg>
                {{removeLables(scope.row.remarkName || scope.row.title)}}（{{scope.row.id}}）
              </a>
              <el-input
                v-else
                class="remarkInput"
                :id="'remarkInput' + scope.row.id"
                @blur="handleBlur(scope.row)"
                v-model="scope.row.remarkName"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column width="120" prop="status" align="center" label="模板状态">
            <template slot-scope="scope">
              <el-select
                class="template-select"
                v-model="scope.row.status"
                style="width: 100px;"
                @change="handleChangeStatus(scope.row)"
              >
                <el-option :value="1" label="开放中"></el-option>
                <el-option :value="2" label="关闭"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="createOwner" align="center" label="编辑人" width="220"></el-table-column>
          <el-table-column prop="referenceCount" align="center" label="引用量">
            <template slot-scope="scope">
              <span class="recycle-count">{{scope.row.referenceCount}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="编辑时间" align="center" width="220"></el-table-column>
          <el-table-column width="300" align="left" label="操作">
            <template slot-scope="scope">
              <a href="javascript:;" class="operate-a" @click="handleRename(scope.row)">重命名</a>
              <a href="javascript:;" class="operate-a" @click="handleDelete(scope.row)">删除</a>
              <a href="javascript:;" class="operate-a" @click="handleCopy(scope.row)">复制</a>
              <i
                class="order-icon el-icon-caret-top"
                :class="{'diable-icon': disableClick(scope.row,'top')}"
                @click="handleTop(scope.row)"
              ></i>
              <i
                class="order-icon el-icon-caret-bottom"
                :class="{'diable-icon': disableClick(scope.row,'bottom')}"
                @click="handleDown(scope.row)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row class="mb40">
        <div class="pager-center">
          <el-pagination
            @current-change="getList"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="totalItem"
          ></el-pagination>
        </div>
      </el-row>
    </div>
    <role-control
      :previewUrl="previewUrl"
      @update:dialogShow="(val) => this.tempDialogShow = val"
      :dialogShow="tempDialogShow"
    ></role-control>
  </div>
</template>

<script>
import { htmlToTxtMixin } from "../utils/mixins.js";
import { mapGetters, mapMutations, mapActions } from "vuex";
import http from "../utils/http";
import { DOMAIN } from "../utils/api";
import { timeToLocal, MSG, exportFile } from "../utils/utils";
import templateBox from "../components/templateBox";
import templateEdit from "./templateEdit";
import templatePreview from "../components/templatePreviewDialog";

import roleControl from "../components/roleControl.vue";

let _id = 0;
export default {
  name: "Template",
  mixins: [htmlToTxtMixin],
  data() {
    return {
      interface: {
        getSurvey: `${DOMAIN}/template/get`,
        getList: `/template/list`,
        copySurvey: `/template/copyTemplate`,
        deleteSurvey: `/template/del`,
        rename: `/template/remarkNameEdit`,
        startRecycle: `/template/open`,
        pauseRecycle: `/template/close`,
        qrcode: `${DOMAIN}/survey/qrcode`,
        outExcel: `${DOMAIN}/stat/exportData`,
        clearData: `/stat/clear`,
        editStat: `/survey/editStat`,
        surveyTitle: `/search/surveyTitle`,
        surveyList: `/search/survey`,
        order: `/template/order`,
        surveyById: `/search/surveyById`
      },
      tableData: [],
      pageSize: 100,
      currentPage: 1,
      totalItem: 10,
      totalCount: -1,
      txtDialogShow: false,
      shareAddr: "",
      isCollecting: false,
      qrcodeUrl: "",
      qrcodeSmall: "",
      qrcodeMid: "",
      qrcodeBig: "",
      qrcodeSL: "",
      excelUrl: "",
      spssUrl: "",
      htmlToTxt: "",
      templateId: "",
      dropDownVal: [],
      canEdit: true,
      titleList: [],
      selectedTitle: "",
      loading: false,
      searchTableData: [],
      isEnter: false,
      copyTitle: "",
      templateId: "",
      timeOpts: [{}],
      boxshow: false,
      tempDialogShow: false,
      previewUrl: "https://wenjuan.58.com/s/?id=1000246&hash=npy5",
      survryS: "1"
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleSelectChange(val) {
      this.selectRow = val;
    },
    handleCreateTempate() {
      this.$router.push({
        path: "/home/templateEdit"
      });
    },
    handleShowControl() {
      this.tempDialogShow = true;
    },
    handleShowPreview(url) {
      this.tempDialogShow = true;
    },
    disableClick(row, direction) {
      let index = this.tableData.indexOf(row);
      if (direction == "top") {
        return index == 0;
      } else {
        return index == this.tableData.length - 1;
      }
    },
    getList() {
      this.tableData.forEach(item => {
        this.$set(item, "checked", false);
      });
      if (this.searchTableData.length) {
        if (
          this.searchTableData.length &&
          this.currentPage < Math.ceil(this.searchTableData.length / 10.0)
        ) {
          this.tableData = this.searchTableData.slice(
            this.currentPage * 10,
            this.currentPage * 10 + 10
          );
          if (this.currentPage) this.currentPage++;
        }
        this._updateSubSurveyBg();
        return;
      }
      http
        .get(this.interface.getList, {
          page: this.currentPage,
          pageSize: this.pageSize
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            this.totalCount = data.totalCount;
            if (this.totalCount == 0) {
              this.tableData = [];
              return;
            }
            data.recordList.forEach(val => {
              val.updateTime = timeToLocal(new Date(+val.updateTime)).date;
              val.editRemark = false;
            });
            this.tableData = data.recordList;
            this.totalItem = data.totalPage * this.pageSize;
            this._updateSubSurveyBg();
          } else {
            MSG.error(message);
          }
          this.$nextTick(() => {
            let ele = this.$el.querySelector(
              ".template-page .mine-list .el-table tr > th"
            );
            ele && (ele.style.paddingLeft = "48px");
          });
        });
    },
    handleChangeStatus(row) {
      if (row.status == 1) {
        this.handleStart(row);
      } else {
        this.handlePause(row);
      }
    },
    handleStart(row, idx) {
      http
        .post(this.interface.startRecycle, {
          templateId: row.id
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            row.status = 1;
            MSG.success(message);
          } else {
            MSG.error(message);
          }
        });
    },
    handlePause(row, cb) {
      http
        .post(this.interface.pauseRecycle, {
          templateId: row.id
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            row.status = 2;
            cb && cb();
            MSG.success(message);
          } else {
            MSG.error(message);
          }
        });
    },
    handleEdit(row) {
      if (row.status !== 2) {
        this.$confirm(
          "执行该操作前需要先关闭模板，是否关闭模板？",
          "请先关闭模板",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            this.handlePause(row, () => {
              this.$router.push({
                path: "/home/templateEdit",
                query: {
                  id: row.id
                }
              });
            });
          })
          .catch(() => {});
      } else {
        this.$router.push({
          path: "/home/templateEdit",
          query: {
            id: row.id
          }
        });
      }
    },
    handleOutputTxt({ id, title }) {
      this.txtDialogShow = true;
      this.templateId = id;
      this.handleHtmlToTxt(id);
    },
    handleTxtDialogClose() {
      this.htmlToTxt = "";
    },
    handleExportIn() {
      exportFile(this.surveyName + ".txt", this.htmlToTxt);
    },
    handleCopy(row) {
      http
        .post(this.interface.copySurvey, {
          templateId: row.id,
          dirId: row.dirId
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            this.copyTitle = (row.remarkName || row.title) + "_副本";
            this.getList();
            MSG.success("问卷复制成功,复制问卷设置清空");
          } else {
            MSG.error(message);
          }
        });
    },
    handleDelete(row) {
      this.$confirm("问卷删除后将无法恢复，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this._deleteSurvey(row);
        })
        .catch(() => {});
    },
    _deleteSurvey(row) {
      console.log(row);
      http
        .get(this.interface.deleteSurvey, {
          templateId: row.id
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            this.getList();
            MSG.success("删除成功");
          } else {
            MSG.error(message);
          }
        });
    },
    handleRename(row) {
      row.remarkName =
        this.removeLables(row.remarkName) || this.removeLables(row.title);
      row.editRemark = true;
      this.$nextTick(() => {
        document.getElementById("remarkInput" + row.id).focus();
      });
    },
    handleBlur(row) {
      row.editRemark = false;
      if (!row.remarkName) {
        MSG.error("重命名不能为空");
        return;
      }
      this._renameSurvey(row);
    },
    _renameSurvey(row) {
      http
        .post(this.interface.rename, {
          templateId: row.id,
          remarkName: row.remarkName
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            MSG.success("保存成功");
          } else {
            MSG.error(message);
          }
        });
    },
    handleOpenUrl() {
      window.open(this.shareAddr);
    },
    handlePreview(row) {
      this.$router.push({
        path: "/preview",
        query: {
          url: row.url
        }
      });
    },
    changeRecycleStatus(row, enable) {
      if (row.status === 1) {
      } else {
      }
    },
    handleSearchSurveyTitle(query) {
      if (query !== "") {
        this.loading = true;
        http
          .get(this.interface.surveyTitle, {
            key: query
          })
          .then(response => {
            this.loading = false;
            const { code, data, message } = response;
            if (code === 1) {
              this.titleList = data;
            } else {
              MSG.error(message);
            }
          })
          .catch(error => {
            this.loading = false;
            MSG.error(error);
          });
      } else {
        this.titleList = [];
      }
    },
    selectSurvey(title) {
      if (title !== "") {
        http
          .get(this.interface.surveyList, {
            key: title
          })
          .then(response => {
            const { code, data, message } = response;
            if (code === 1) {
              this.totalCount = data.length;
              data.forEach(val => {
                val.updateTime = timeToLocal(new Date(+val.updateTime)).date;
                val.editRemark = false;
              });
              this.searchTableData = data;
              this.tableData = this.searchTableData.slice(0, 10);
              this.totalItem = data.length;
              this.currentPage = 1;
              this.pageSize = 100;
            } else {
              MSG.error(message);
            }
          })
          .catch(error => {
            MSG.error(error);
          });
      }
    },
    handleSelectSurvey() {
      this.selectSurvey(this.selectedTitle);
      this.isEnter = false;
    },
    handleSearchSurvey() {
      this.$refs.select.handleClose();
      let val = this.$el.querySelector(".el-select .el-input input").value;
      this.selectedTitle = val;
      if (val) {
        this.selectSurvey(val);
        this.isEnter = true;
      } else {
        this.searchTableData = [];
        this.getList();
      }
    },
    handleSearchSurveyByID() {
      if (this.templateId) {
        http
          .get(this.interface.surveyById, {
            templateId: this.templateId
          })
          .then(response => {
            const { code, data, message } = response;
            if (code === 1) {
              this.totalCount = data.length;
              data.forEach(val => {
                val.updateTime = timeToLocal(new Date(+val.updateTime)).date;
                val.editRemark = false;
              });
              this.tableData = data;
              this.totalItem = data.length;
              this.currentPage = 1;
              this.pageSize = 100;
            } else {
              MSG.error(message);
            }
          })
          .catch(error => {
            MSG.error(error);
          });
      }
    },
    handleSelectBlur() {
      if (this.isEnter) {
        this.selectedTitle = this.$el.querySelector(
          ".el-select .el-input input"
        ).value;
      }
    },
    handleTop(row) {
      let index = this.tableData.indexOf(row);
      if (index != 0) {
        let topRow = this.tableData[index - 1];
        this.exchangeOrder(topRow, row);
      }
    },
    handleDown(row) {
      let index = this.tableData.indexOf(row);
      if (index !== this.tableData.length - 1) {
        let bottomRow = this.tableData[index + 1];
        this.exchangeOrder(row, bottomRow);
      }
    },
    exchangeOrder(topRow, downRow) {
      http
        .get(this.interface.order, {
          upId: topRow.id,
          downId: downRow.id
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            this.getList();
            // MSG.success(message);
          } else {
            MSG.error(message);
          }
        });
    },
    _updateSubSurveyBg() {
      this.$nextTick(() => {
        let ele = this.$el.querySelector(
          ".template-page .mine-list .el-table tbody"
        );
        if (!ele) return;
        let trEles = ele.children;
        this.tableData.forEach((item, index) => {
          if (item.type == 1 && item.hash) {
            trEles[index].style.backgroundColor = "#FCEFED";
          } else if (item.subSurvey) {
            trEles[index].style.backgroundColor = "#F8F8F8";
          } else {
            trEles[index].style.backgroundColor = "#FFFFFF";
          }
          if (item.title == this.copyTitle) {
            trEles[index].style.backgroundColor = "#F5F7FA";
          }
        });
      });
    }
  },
  components: {
    roleControl,
    templateEdit
  }
};
</script>

<style lang="scss">
.template-page {
  height: 100%;
  background: #fff;
  overflow-y: scroll;
  padding-bottom: 60px;
  .remarkInput {
    width: 200px;
    input {
      height: 30px;
      line-height: 14px;
      font-size: 14px;
      padding: 8px;
    }
  }
  .survey-container {
    min-height: 400px;
    margin-left: 50px;
    margin-right: 50px;
    background-color: #fff;
    position: relative;
    z-index: 10;
  }
  .empty-page {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    .collect-btn {
      margin-top: 15px;
      width: 150px;
    }
  }
  .el-button--primary {
    font-weight: normal;
  }
  .mine-header {
    width: 100%;
    height: 60px;
    line-height: 60px;
    background-color: #fff;
    z-index: 999;
    padding-left: 20px;
    border-bottom: 1px solid #eaeaea;
    .create-btn-box {
      display: inline-block;
      a {
        display: inline-block;
      }
      .create-btn {
        margin-left: 20px;
      }
    }
  }
  .views-control {
    a {
      height: 60px;
      padding: 0 15px;
      float: left;
      color: #333;
      border-left: 1px solid #e1e6eb;
      i {
        font-size: 24px;
        color: #999;
        vertical-align: sub;
        margin-right: 8px;
      }
      &:hover,
      &.active {
        color: #ff552e;
        i {
          color: #f1b6a7;
        }
      }
    }
  }
  .mine-list {
    .el-icon-arrow-down:before {
      content: "\E646";
    }
    .el-input__suffix-inner:hover {
      color: #ff552e;
    }
  }
  .el-table {
    &.el-table--fit {
      border: 1px solid #ebeef5;
      border-bottom: none;
    }
    .cell {
      padding-left: 0;
      padding-right: 0;
    }
    th {
      font-weight: normal;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #999999;
      letter-spacing: 0;
      line-height: 18px;
    }
    tbody tr {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666666;
      letter-spacing: 0;
    }
    .pause-icon,
    .collect-icon {
      display: inline-block;
      width: 10px;
      height: 10px;
      background-color: #ff552e;
      border-radius: 50%;
      margin-right: 5px;
    }
    .collect-icon {
      background-color: #479de6;
    }
    .wj-name {
      height: 34px;
      line-height: 34px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666666;
      letter-spacing: 0;
      margin-left: 50px;
      cursor: pointer;
      position: relative;
      bottom: 3px;
      &:hover {
        color: #ff552e;
      }
    }
    .el-button--default {
      background-color: transparent;
      border: 0;
    }
  }
  .share-dialog {
    .nocollect-tips {
      color: #ff552e;
      margin-bottom: 20px;
    }
    h2 {
      font-size: 18px;
      margin-bottom: 15px;
    }
    .share-addr {
      margin-bottom: 20px;
      .el-input {
        width: calc(100% - 170px);
        margin-right: 10px;
      }
    }
    .share-qrcode {
      img {
        width: 150px;
        height: 150px;
        border: 1px solid #ccc;
        border-radius: 8px;
        vertical-align: middle;
      }
      p {
        display: inline-block;
        margin-top: 20px;
        margin-left: 20px;
      }
      .linkbox {
        display: inline-block;
        vertical-align: middle;
        margin-left: 30px;
      }
      .qrcodeLink {
        color: #58a6e7;
        display: block;
      }
    }
  }
  .el-table thead {
    background: #fff;
  }
  .el-table tr,
  .el-table th,
  .el-table td {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
    height: 50px !important;
  }
  .el-input__suffix {
    color: #999;
  }
  .el-dialog__body {
    padding: 20px 40px 50px 40px;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .mb40 {
    margin-bottom: 40px;
  }
  .pager-center {
    display: flex;
    justify-content: center;
  }
  .el-dialog__footer {
    text-align: center;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-cascader {
    .el-input__inner {
      border: none;
      width: 20px;
      padding: 0 25px;
      background-color: transparent;
    }
    .el-cascader__label {
      display: none;
    }
  }
}
.el-dropdown-menu__item {
  padding: 0;
  a {
    display: block;
    padding: 0 20px;
  }
}
.view-search {
  position: relative;
}
.fixed-button {
  position: absolute;
}
.el-cascader-menu {
  height: auto;
}
.el-cascader-menus.el-popper {
  ul:last-child:not(:nth-child(2)) {
    position: absolute;
    top: 70px;
    height: 150px;
    border: 1px solid #eee;
  }
  ul:nth-child(2) li:nth-child(8) {
    border-bottom: 1px solid #eee;
  }
  ul:nth-child(2) li:nth-child(4) {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
  }
}
.wj-icon {
  width: 20px;
  height: 15px;
  padding-left: 5px;
  display: inline-block;
  vertical-align: sub;
  background-image: url(../assets/sprite@3x.png);
  background-size: 525px 875px;
}
.template-page .wj-survey-icon {
  position: relative;
  top: 8px;
  width: 28px;
  height: 30px;
  left: -5px;
}
.template-header {
  display: flex;
  justify-content: space-between;
  height: 60px;
  line-height: 60px;
  padding-left: 10px;
  background-color: #fff;
  position: relative;
  padding-left: 60px;
}

.operate-a {
  display: inline-block;
  padding-right: 20px;
  &:hover {
    color: #ff552e;
  }
}
.order-icon {
  cursor: pointer;
  position: relative;
  left: 15px;
  &:hover {
    color: #ff552e;
  }
  &.diable-icon {
    cursor: not-allowed;
    color: #ccc;
  }
}

.zhiding-a {
  color: #ff552e;
  cursor: pointer;
  display: inline-block;
  width: 80px;
}
.recycle-count:hover {
  color: #ff552e;
}
.template-select input {
  height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/views/template.vue